import { LoanOfficerDetail } from "pages/application/applicationService";
import { LOAN_OFFICER_CALL_QUEUE } from "utilities/Constant";

export interface LoDisplayFields {
  title?: string;
  email?: string;
  phone?: string;
}

const firstNonEmpty = (...values: (string | null | undefined)[]): string | undefined =>
  values.find((value) => !!value && value.trim().length > 0) ?? undefined;

export const getLoDisplayFields = (loInfo?: LoanOfficerDetail | null): LoDisplayFields => ({
  title: firstNonEmpty(loInfo?.micrositeDisplayJobTitle, loInfo?.jobTitle),
  email: firstNonEmpty(loInfo?.micrositeDisplayEmail, loInfo?.workEmail),
  phone: firstNonEmpty(loInfo?.micrositeDisplayPhoneNumber, loInfo?.phones?.[0]?.number),
});

const EMPTY_LOAN_OFFICER_USER_ID = "00000000-0000-0000-0000-000000000000";
export const isCallQueueOrEmptyLoanOfficer = (loInfo?: LoanOfficerDetail | null): boolean => {
  if (!loInfo) return true;
  const name = (loInfo.fullName || loInfo.name || "").trim();
  const hasNoValidName = name === "" || name === LOAN_OFFICER_CALL_QUEUE;
  const hasNoValidUserId = !loInfo.userId || loInfo.userId === EMPTY_LOAN_OFFICER_USER_ID;
  return hasNoValidName || hasNoValidUserId;
};

export type LoSalesChannel = "retail" | "consumer direct";

export const getLoSalesChannel = (loInfo?: LoanOfficerDetail | null): LoSalesChannel | undefined => {
  const domainName = (loInfo?.domains?.[0]?.domainName ?? "").trim().toLowerCase();
  if (domainName === "retail") return "retail";
  if (domainName === "cd") return "consumer direct";
  return undefined;
};

export type LoPhoneType = "mobile" | "office" | "work";

export const getLoPhoneType = (type?: string | null): LoPhoneType | undefined => {
  switch ((type ?? "").trim().toLowerCase()) {
    case "cell":
    case "directdial":
      return "mobile";
    case "work":
    case "work2":
      return "office";
    case "home":
      return "work";
    default:
      return undefined;
  }
};
